import styled from "styled-components";

export const DimensionListContainer = styled.div``;